import * as React from "react";
import { JsonLd } from "../../../StructuredData/JsonLd.js";
const WebPage = ({ pageType, url, ...rest }) => {
  const cleanUrl = url?.split("?")[0];
  if (!cleanUrl) {
    return null;
  }
  const payload = {
    "@type": "WebPage",
    "@id": cleanUrl,
    ...pageType ? { additionalType: `https://grandvision.com/#/PageType/${pageType}` } : {},
    ...rest,
    url: cleanUrl
  };
  return /* @__PURE__ */ React.createElement(JsonLd, { ...payload });
};
export {
  WebPage
};
//# sourceMappingURL=WebPage.sd.js.map
